import { BaseService } from '../base';

export type ConstructionType = {
  id: string;
  code: string;
  description: string;
};

export type ConstructionTypesMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type ConstructionTypesResponse = {
  data: ConstructionType[];
  meta: ConstructionTypesMeta;
};

export type GetConstructionTypesParams = {
  sortType?: 'ASC' | 'DESC';
  sortField?: string;
  pageSize?: number;
  pageNumber?: number;
};

export class ConstructionTypesService extends BaseService {
  async getConstructionTypes(): Promise<{
    success: boolean;
    data?: ConstructionTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/product-lines/homeowner/construction-types?`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<ConstructionTypesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar tipos de construção',
      };
    }
  }
}

export const constructionTypesService = new ConstructionTypesService();
